import { useApolloClient } from '@apollo/client';
import { updateSubscriptionCache } from 'src/apollo/cache/update';
import { StripeAddressParam, useCreateSubscriptionMutation } from 'src/generated/graphql';

interface CreateSubscriptionVariables {
  paymentMethod: string;
  plan: string;
  hostingPlan?: string | undefined;
  isEuropeanUnion: boolean;
  company: { vatNumber: string; name: string };
  withTrial: boolean;
  promoCode: string;
  address: StripeAddressParam;
}

export default function useCreateSubscription() {
  const client = useApolloClient();

  const [createSubscriptionMutation] = useCreateSubscriptionMutation();

  const createSubscription = (variables: CreateSubscriptionVariables) => {
    return createSubscriptionMutation({
      variables,
      refetchQueries: ['permissions'],
      awaitRefetchQueries: true,
    }).then(res => {
      const subscription = res.data?.createSubscription;
      if (subscription) {
        updateSubscriptionCache({ client, subscription });
      }
      return res.data?.createSubscription;
    });
  };

  return createSubscription;
}
